import { FilterOptionsState } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteOption, LwFormAutocomplete } from 'redesign';
import { WorkFormCompanyInfo, WorkFormContext } from 'shared/components/work-forms/work-form.types';

export type CompanyFormContext = {
  companyOption: AutocompleteOption | null;
};

export const CompanyInput = ({
  companies,
  disabled,
}: {
  companies: WorkFormCompanyInfo[];
  disabled: boolean;
}) => {
  const { control, setValue } = useFormContext<WorkFormContext>();

  const companiesOptions: AutocompleteOption[] = useMemo(
    () =>
      companies.map((company) => ({
        value: company.id,
        label: company.name,
      })),
    [companies]
  );

  const filterOptions = useCallback(
    (autocompleteOptions: AutocompleteOption[] | null, state: FilterOptionsState<any>) => {
      return (
        autocompleteOptions?.filter((option) =>
          option.label.toLowerCase().includes(state.inputValue.toLowerCase())
        ) ?? []
      );
    },
    []
  );

  return (
    <LwFormAutocomplete
      name="companyOption"
      label="Company"
      options={companiesOptions}
      control={control}
      disabled={disabled}
      getOptionKey={(option) => option.value}
      getOptionLabel={(option) => option.label ?? ''}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      filterOptions={filterOptions}
      onChange={(_e, value) => {
        setValue('companyOption', value);
      }}
      rules={{ required: 'Selecteer een bedrijf' }}
      isLoading={false}
      data-testid="company-autocomplete"
    />
  );
};
